export default __webpack_public_path__ + "static/media/caret.e85054ed.svg";